import React, { useState } from 'react';
import styled from 'styled-components';
import DoneIcon from '@material-ui/icons/Done';

import { Typography } from '../typography';
import down from '../../assets/images/chevron-down.png';
import up from '../../assets/images/chevron-up.png';
import colors from '../../assets/colors';

const Main = styled('div')`
	font-family: sans-serif;
	background: #fff;
	margin-top: 10px;
`;

const DropDownContainer = styled('div')`
	width: 100%;
	margin: 0 auto;
`;

const DropDownHeader = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 0.8em;
	padding: 0.4em 0.8em 0.4em 0.8em;
	border: 1px solid #ccd2d9;
	border-radius: 10px;
	font-weight: 500;
	font-size: 1.3rem;
	color: #3faffa;
	height: 50px;

	&:hover {
		cursor: pointer;
	}
	@media (max-width: 1300px) {
		padding: 0.2em 0.4em;
	}
`;

const DropDownListContainer = styled('div')`
	position: absolute;
	border-radius: 10px;
	z-index: 100;
	width: 438px;
	overflow: hidden;
`;

const DropDownList = styled('ul')`
	padding: 8px;
	margin: 0;
	border: 1px solid #ccd2d9;
	border-radius: 10px;
	background: #f7f7f9;
	box-sizing: border-box;
	max-height: 200px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #ccd2d9;
	}
	&:hover {
		:-webkit-scrollbar-thumb {
			background-color: #ccd2d9;
		}
	}
`;

const ListItem = styled('li')`
	display: flex;
	align-items: center;
	list-style: none;
	border-radius: 12px;
	padding: 8px;

	&:hover {
		cursor: pointer;
		background-color: ${p => p.theme.colors.btnGreen};
	}
`;

interface IPropsBtn {
	isActive: boolean;
}

const SmallBtn = styled.div<IPropsBtn>`
	/* flex-direction: row; */
	background-color: ${p => p.theme.colors[p.isActive ? 'btnGreen' : 'white']};
	border: 1px solid ${p => p.theme.colors[p.isActive ? 'black' : 'border']};
	border-radius: 6px;
	align-items: center;
	justify-content: center;
	height: 28px;
	min-width: 28px;
	margin-right: 10px;
`;

const MultiSelect = ({ options, value, image, callback }: any) => {
	const [isOpen, setIsOpen] = useState(false);
	const toggling = () => setIsOpen(!isOpen);

	const onOptionClicked = (option: any) => () => {
		callback(option);
		// setIsOpen(false);
	};

	return (
		<Main>
			<DropDownContainer>
				<DropDownHeader onClick={toggling}>
					<Typography
						text={`Set fields (${value.length + '/' + options.length})`}
						type="bold"
						size="normal"
					/>
					<img
						src={image ? image : !isOpen ? down : up}
						style={{ height: image ? 14 : 8 }}
						alt=""
					/>
				</DropDownHeader>
				{isOpen && (
					<DropDownListContainer>
						<DropDownList>
							{options.map((option: any) => {
								const isActive = value.includes(option.value);
								return (
									<ListItem
										onClick={onOptionClicked(option)}
										key={Math.random()}
									>
										<SmallBtn isActive={isActive}>
											{isActive ? (
												<div
													style={{
														display: 'flex',
														height: '100%',
														alignItems: 'center',
														justifyContent: 'center',
													}}
												>
													<DoneIcon
														fontSize="small"
														style={{
															color: colors.black,
														}}
													/>
												</div>
											) : null}
										</SmallBtn>
										<Typography text={option.title} type="bold" size="normal" />
									</ListItem>
								);
							})}
						</DropDownList>
					</DropDownListContainer>
				)}
			</DropDownContainer>
		</Main>
	);
};

export default MultiSelect;
